import { Address, UserInfo } from "./user";

export enum TaskStatus {
  APPROVED = "approved",
  REJECTED = "rejected",
  PENDING = "pending",
}

export enum TaskType {
  WITHDRAWAL = "withdrawl",
  REFUND = "refund",
  BANK_ACCOUNT_UPDATE = "bank_account_update",
  EVENT_CREATION = "event_creation",
  EVENT_CANCELLATION = "event_cancellation",
}

export interface TaskEventCategory {
  id: number;
  title: string;
}

export interface TaskEvent {
  id: number;
  online: boolean;
  platform_url: string;
  title: string;
  description: string;
  thumbnail: string;
  additional_images: string[];
  start_date: string;
  end_date: string;
  accepted_terms: boolean;
  is_private: boolean;
  status: string;
  event_category: TaskEventCategory;
  address: Address;
  organizer_name: string;
  sold_quantity: number;
  total_revenue: number | string;
}

export interface TaskRequester {
  data: {
    id: string;
    type: string;
    attributes: UserInfo;
  };
}

export interface BaseTaskRequest {
  id: number;
  task_type: TaskType;
  status: TaskStatus;
  created_at: string;
  updated_at: string;
  documents?: TaskDocument[];
}

export interface EventCreationTask extends BaseTaskRequest {
  task_type: TaskType.EVENT_CREATION;
  event: TaskEvent;
  requester: TaskRequester;
}

export interface EventCancellationTask extends BaseTaskRequest {
  task_type: TaskType.EVENT_CANCELLATION;
  title: string;
  description: string;
  event_id: number;
  user_id: number;
  requester: TaskRequester;
}

export interface TaskBankAccount {
  bank_name: string;
  bank_code: string;
  agency: string;
  account_number: string;
  account_digit: string;
  account_holder: string;
  pix_key: string;
}

export interface TaskDocument {
  id: number;
  title: string | null;
  url: string;
  created_at?: string;
}

export interface WithdrawalTask extends BaseTaskRequest {
  task_type: TaskType.WITHDRAWAL | TaskType.REFUND;
  title: string;
  description: string;
  amount: string | number;
  order_id: number | null;
  user_id: number;
  bank_account_id: number | null;
  event_id: number | null;
  requested_changes: Record<string, unknown>;
  requester: TaskRequester;
  bank_account: TaskBankAccount | null;
  documents?: TaskDocument[];
}

export interface BankAccountUpdateTask extends BaseTaskRequest {
  task_type: TaskType.BANK_ACCOUNT_UPDATE;
  title: string;
  description: string;
  amount: null;
  order_id: null;
  user_id: number;
  bank_account_id: number;
  event_id: null;
  requested_changes: TaskBankAccount;
}

export type TaskRequest =
  | EventCreationTask
  | EventCancellationTask
  | WithdrawalTask
  | BankAccountUpdateTask;

export interface TaskSummary {
  approved: number;
  rejected: number;
  pending: number;
}

export interface RequestWithdrawalTask {
  title: string;
  task_type: TaskType.WITHDRAWAL | TaskType.REFUND;
  description: string;
  amount: number;
  invoice_url?: string;
  invoice_title?: string;
}

export interface RequestRefundTask {
  title: string;
  task_type: TaskType.REFUND;
  description: string;
  amount: number;
  order_id: number;
  customer_reason: string;
}
